import { __decorate, __extends, __metadata } from "tslib";
import NeoModel from '../../Model/NeoModel';
import ValueObject from '../../Model/ValueObject';
var PageRequest = /** @class */ (function (_super) {
    __extends(PageRequest, _super);
    function PageRequest(criteria) {
        var _this = _super.call(this) || this;
        _this.criteria = criteria;
        /**
         * Zero based page start index.
         */
        _this.pageIndex = 0;
        /**
         * No of records to include in the page.
         */
        _this.pageSize = 20;
        /**
         * True if the total no of available records is not required.
         */
        _this.noCount = false;
        /**
         * List of sort operations to perform.
         */
        _this.sortColumns = [];
        return _this;
    }
    PageRequest.prototype.toQueryObject = function () {
        var base = _super.prototype.toJSObject.call(this, { suppressTrackingState: true });
        // Serialiser doesn't include arrays for query objects. We also need to pass the property name string, not the property info oject.
        base.sortColumns = this.sortColumns.map(function (s) { return ({ columnName: s.column.propertyName, sortAscending: s.sortAscending }); });
        return base;
    };
    PageRequest = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Object])
    ], PageRequest);
    return PageRequest;
}(ValueObject));
export { PageRequest };
